// @flow
/**
 * Create a flight object given the provided airline and flight.
 * @param {String} airline Flight data
 * @param {String} flight Flights airline code
 * @return {Fligh}
 */
export const createFlight = (airline: String, flight: String) => {
  if (!airline || !flight) {
    return null
  }

  return {
    time: '',
    origin: '',
    destination: '',
    airlineName: airline,
    airlineCode: airline,
    flightCode: `${airline.substring(0, 3).toUpperCase()}${flight.toString()}`,
    flightNumber: flight,
  }
}

export default createFlight
